import * as React from 'react';
import {ControlButton, TscButtonType, Glyphs} from '@techsmith/tsc-cloud-style-guide';
import Strings from '../../globals/Strings';
import Constants from '../../globals/Constants';
import {RouteComponentProps, withRouter} from 'react-router';
import Themeable from '../../types/Themeable';
import Config from '../../globals/Config';

export default withRouter(({history, themeName, dashboardFilter}: DashboardButtonProps) => {
   const onDashboardClick = () => {
      history.push(dashboardFilter ? `${Constants.siteLinks.dashboard}?filter=${dashboardFilter}` : Constants.siteLinks.dashboard);
   };

   return Config.user.isAuthenticated && <ControlButton
      themeName={themeName}
      buttonType={TscButtonType.tertiary}
      glyph={<Glyphs.ArrowLeft16x16/>}
      onClick={onDashboardClick}
      title={Strings.labels.dashboard}
      testId="dashboard-button"
   />;
});

export interface DashboardButtonProps extends RouteComponentProps, Themeable {
   currentUserId: string;
   dashboardFilter: string;
}
